<template>
    <svg
        class="phone-icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.5 3.83333C10.942 3.83333 11.366 4.00893 11.6785 4.32149C11.9911 4.63405 12.1667 5.05797 12.1667 5.5M10.5 0.5C11.8261 0.5 13.0979 1.02678 14.0355 1.96447C14.9732 2.90215 15.5 4.17392 15.5 5.5M2.16667 1.33333H5.5L7.16667 5.5L5.08333 6.75C5.9758 8.55961 7.44039 10.0242 9.25 10.9167L10.5 8.83333L14.6667 10.5V13.8333C14.6667 14.2754 14.4911 14.6993 14.1785 15.0118C13.866 15.3244 13.442 15.5 13 15.5C9.74939 15.3025 6.68346 13.9221 4.38069 11.6193C2.07792 9.31654 0.697541 6.25061 0.5 3C0.5 2.55797 0.675595 2.13405 0.988155 1.82149C1.30072 1.50893 1.72464 1.33333 2.16667 1.33333Z"
            :stroke="color"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'PhoneIcon',
    props: {
        color: {
            type: String,
            default: '#BEBEBE'
        }
    }
}
</script>
